<template>
  <div id="app">
    <div class="loading-screen" v-show="!loaded">
      <img :src="icon_url" class="rotating" />
    </div>
    <div v-show="loaded">
      <div :class="{'viewer-fixed-container': true, expanded: expanded}">
        <div class="viewer-fixed">
          <model-viewer class="model" :fallback-image="modelFallbackImage" :model-url="modelUrl" ref="viewer" />
        </div>
      </div>
      <div class="remaining">
        <div class="controls-3d">
          <button @click="zoomin"><i class="icon-zoomin"></i></button>
          <button @click="zoomout"><i class="icon-zoomout"></i></button>
          <button @click="spin"><i class="icon-spinner6"></i></button>
          <button @click="expand"><i :class="{'icon-expand': !expanded, 'icon-contract': expanded}"></i></button>
        </div>
        <div class="container">
          <h1 class="col12 konfigurator-h1">Werkzeugkonfigurator für Fenster- & Türschnitte</h1>
          <konfigurator id="konfigurator" ref="konfigurator" class="part" @change="hideShortlink" @modelChange="setModelUrl" />
          <maschinen-auswahl id="maschinen-auswahl" ref="maschinen" class="part" @change="hideShortlink" />
          <individuelle-anforderungen id="individuelle-anforderungen" ref="anforderungen" class="part" @change="hideShortlink" />
          <kontakt-informationen id="kontakt-informationen" ref="kontakt" class="part" />
          <div class="buttons">
            <button :class="{senden: true, completed: anfrageCompleted && anfrageSuccess}" @click="anfrageSenden">
              <template v-if="!(anfrageCompleted && anfrageSuccess)">
                Anfrage senden
              </template>
              <template v-else>
                <i class="icon-checkmark2"></i>
                Anfrage gesendet
              </template>
            </button>
            <button @click="shortlinkEmail">Konfiguration per E-Mail versenden</button>
            <div :class="{projektlink: true, show: show_shortlink}">
              <button class="projektlink" @click="create_shortlink">Projektlink erzeugen</button>
              <input type="text" :value="shortlink" ref="shortlink_input" />
              <button class="copy-button" @click="copyShortlink"><i class="icon-copy"></i></button>
            </div>
          </div>
          <div class="col12" v-if="anfrageCompleted && anfrageSuccess">
            <div class="completed-message">
              <h3>Vielen Dank für ihre Anfrage. Wir werden baldmöglichst auf Sie zukommen.</h3>
              <p>Für Ihre Fragen stehen wir gerne und kompetent unter Telefon <a href="tel:+49738798730">+49 (0)7387-9873-0</a> oder per E-Mail <a href="mail:info@zuani.de">info@zuani.de</a> zu Ihrer Verfügung.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Konfigurator from '@/components/Konfigurator'
import MaschinenAuswahl from '@/components/MaschinenAuswahl'
import IndividuelleAnforderungen from '@/components/IndividuelleAnforderungen'
import KontaktInformationen from '@/components/KontaktInformationen'
import ModelViewer from '@/components/ModelViewer'
import Options from '@/Options'

export default {
  name: 'App',
  components: {
    Konfigurator,
    MaschinenAuswahl,
    IndividuelleAnforderungen,
    KontaktInformationen,
    ModelViewer
  },
  methods: {
    expand () {
      this.expanded = !this.expanded
    },
    spin () {
      this.$refs.viewer.spin()
    },
    zoomin () {
      this.$refs.viewer.zoomin()
    },
    zoomout () {
      this.$refs.viewer.zoomout()
    },
    setModelUrl (name) {
      this.modelUrl = BASE_URL + 'models/' + name + '.wrl'
      console.log(this.modelUrl)
    },
    create_shortlink (cb) {
      let data = {
        schnitte: this.$refs.konfigurator.getSchnitte(),
        maschinen: this.$refs.maschinen.getMaschinen(),
        anforderungen: this.$refs.anforderungen.getAnforderungen()
      }
      let formdata = new FormData()
      formdata.append('action', 'konfigurator_shortlink_create')
      formdata.append('data', encodeURIComponent(JSON.stringify(data)))
      fetch(AJAX.url, {
        method: 'POST',
        body: formdata
      })
        .then(response => response.json())
        .then(data => {
          this.shortlink = SETTINGS.shortlink_prefix + data.shortlink
          this.show_shortlink = true
          if (typeof cb === 'function') {
            cb()
          }
        })
        .catch(error => {
          console.warn(error)
        })
    },
    hideShortlink () {
      this.show_shortlink = false
    },
    copyShortlink () {
      this.$refs.shortlink_input.focus()
      this.$refs.shortlink_input.select()

      try {
        let successful = window.document.execCommand('copy')
        let msg = successful ? 'successful' : 'unsuccessful'
        console.log('Copying text command was ' + msg)
      } catch (err) {
        console.log('Oops, unable to copy')
      }
    },
    anfrageSenden () {
      if (this.anfrageCompleted && this.anfrageSuccess) {
        return
      }
      if (!this.$refs.kontakt.validate()) {
        return
      }
      let data = {
        schnitte: this.$refs.konfigurator.getSchnitte(),
        maschinen: this.$refs.maschinen.getMaschinen(),
        anforderungen: this.$refs.anforderungen.getAnforderungen(),
        kontakt: this.$refs.kontakt.getKontakt()
      }
      let formdata = new FormData()
      formdata.append('action', 'konfigurator_angebot')
      formdata.append('data', encodeURIComponent(JSON.stringify(data)))
      fetch(AJAX.url, {
        method: 'POST',
        body: formdata
      })
        .then(response => response.json())
        .then(data => {
          this.anfrageCompleted = true
          if (data.success === true) {
            this.anfrageSuccess = true
          } else {
            this.anfrageSuccess = false
          }
        })
        .catch(error => {
          console.log(error)
          this.anfrageError = true
        })
    },
    shortlinkEmail () {
      this.create_shortlink(() => {
        window.location.href = 'mailto:?subject=' + encodeURIComponent('Link zur Fenster- und Türschnitt-Konfiguration auf ZUANI.de') + '&body=' +
          encodeURIComponent('Guten Tag,\n' +
          '\n' +
          'anbei sende ich Ihnen die Fenster- und Türschnitt-Konfiguration: ' + this.shortlink + '\n' +
          '\n' +
          'Mit besten Grüßen')
      })
    }
  },
  data () {
    window.app = this
    return {
      icon_url: BASE_URL + 'icon.png',
      loaded: false,
      modelFallbackImage: BASE_URL + 'default_model.png',
      modelUrl: '',
      expanded: false,
      show_shortlink: false,
      shortlink: '',
      anfrageSuccess: false,
      anfrageCompleted: false,
      anfrageError: false
    }
  },
  computed: {
  },
  created () {
    Options.getOptions().then(options => {
      this.loaded = true
    })
    let loadShortlink = () => {
      if (window.location.hash.length > 1) {
        let id = window.location.hash.substr(1)
        fetch(AJAX.url + '?action=konfigurator_shortlink_resolve&shortlink=' + id)
          .then(response => {
            return response.json()
          })
          .then(data => {
            if (data.success === true) {
              console.log(data)
              this.$refs.konfigurator.setSchnitte(data.data.schnitte)
              this.$refs.maschinen.setMaschinen(data.data.maschinen)
              this.$refs.anforderungen.setAnforderungen(data.data.anforderungen)
            }
          })
          .catch(error => console.log(error))
      }
    }
    loadShortlink()
    window.addEventListener('hashchange', loadShortlink)
  },
  mounted () {
  }
}
</script>
<style scoped lang="scss">
.controls-3d {
  position: absolute;
  right: 48px;
  top: -48px;
}

.controls-3d button {
  height: 36px;
  width: 36px;
  color: white;
  line-height: 38px;
  padding: 0;
  margin-left: 6px;
  font-size: 19px;
}

.controls-3d .icon-spinner6::before {
  transform: rotate(-45deg);
  display: inline-block;
}

.konfigurator-h1 {
  padding-top: 24px;
}

.konfigurator-h1::after {
  content: ' ';
  border-bottom: 2px solid #ec6608;
  width: 20%;
  height: 6px;
  display: block;
}

#app {
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
}

.loading-screen {

}

.viewer-fixed {
  position: fixed;
  height: 100%;
  width: 100%;
}

.viewer-fixed-container {
  position: relative;
  height: 60vh;
}

.viewer-fixed-container.expanded {
  height: calc(100vh - 50px);
}

@media only screen and (min-width: 1100px) {
  .viewer-fixed-container.expanded {
    height: calc(100vh - 90px);
  }
}

.remaining {
  position: relative;
  background-color: rgba(255,255,255,0.95);
  padding-bottom: 72px;
}

@media screen and (max-width: 480px) {
  .remaining {
    padding-left: 12px;
    padding-right: 12px;
  }
}

.remaining > .container {
  overflow: hidden;
}

.part {
  display: block;
  clear: both;
  overflow: hidden;
  margin-top: 48px;
}

.loading-screen > img {
  display: block;
  margin: 20px auto;
}

@keyframes rotating {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.rotating {
  animation: rotating 4s linear infinite;
}

.buttons {
  margin-top: -13px;
  padding-right: 15px;
}

.buttons::after {
  content: '';
  display: table;
  clear: both;
}

.buttons button {
  background-color: #e6e6e6;
  color: #54565a;
  border-bottom: 2px solid #54565a;
  margin-left: 12px;
  padding-left: 36px;
  padding-right: 36px;
}

.buttons > * {
  float: right;
}

.buttons button:hover {
  background-color: white;
}

.buttons button.senden {
  background-color: #ec6608;
  color: white;
  border-color: #d85200;
  font-weight: bold;
}

.buttons button.senden.completed {
  background-color: #e6e6e6;
  color: #54565a;
  border-bottom: 2px solid #54565a;
  cursor: default;
}

.buttons button.senden.completed:hover {
  background-color: #e6e6e6;
}

.buttons button.senden:hover {
  background-color: #d85200;
}

.buttons div.projektlink {
  position: relative;
}

#app .buttons div.projektlink input {
  position: absolute;
  top: 0;
  left: -50px;
  width: 251px;
  height: 52px !important;
  border-bottom: 2px solid #54565a !important;
  display: none;
}

#app .buttons div.projektlink input::-ms-clear {
  display: none;
}

.buttons div.projektlink .copy-button {
  position: absolute;
  height: 52px;
  width: 52px;
  padding: 0;
  top: 0;
  right: 0;
  z-index: 0;
}

.buttons button.projektlink {
  width: 240px;
}

.buttons div.projektlink.show input, .buttons div.projektlink.show .copy-button {
  display: block !important;
  z-index: 1;
}

.completed-message {
  padding: 12px 24px;
  background-color: white;
  border-bottom: 2px solid #ec6608;
  border-left: 1px solid #e0e0e0;
  width: 100%;
  float: right;
  margin-top: 36px;
  @media screen and (min-width: 768px) {
    width: 70%;
  }
  @media screen and (min-width: 1024px) {
    width: 75%;
  }
  @media screen and (min-width: 1100px) {
    width: 80%;
  }
}

</style>

<style lang="scss">
@import "assets/tabs.scss";

.container {
  margin: 0 auto;
  width: 1170px;
}

.tabs-container {
  background-color: white;
  border-bottom: 2px solid #ec6608;
}

.tabset .tab {
  background-color: white !important;
  text-align: left !important;
}

.footer {
  z-index: 100 !important;
}

#app input, #app select {
  height: 36px !important;
  line-height: 36px !important;
  margin-bottom: 0 !important;
}

#top {
  display: none !important;
}

@media screen and (max-width: 480px) {
  #app .container {
    width: 100%;
    max-width: 100%;
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue